import { LevelType } from 'data/types';
import { isAddingHeatingOrCooling } from 'utils/level-conditioning';
import { sortLevelsByVerticalPosition } from 'utils/structure-basics';
import {
  getBaseLayoutOrderedLevels,
  sortLevelsConditionedFirst
} from 'utils/structure-layout-order';
import { isAddSpacesLevelStepAutoSkippable } from 'utils/structure-step-auto-skip';

export function levelRequiresSpaces(level: LevelType): boolean {
  return level.type !== 'crawlspace' && isAddingHeatingOrCooling(level);
}

export function levelHasSpaces(level: LevelType): boolean {
  return level.sections.some((section) => section.spaces.length > 0);
}

export function isAddSpacesLevelComplete(level: LevelType): boolean {
  return !levelRequiresSpaces(level) || levelHasSpaces(level);
}

export function getAddSpacesNavigableLevels(
  structure: LevelType[]
): LevelType[] {
  return sortLevelsConditionedFirst(
    sortLevelsByVerticalPosition(structure).filter(
      (level) => !isAddSpacesLevelStepAutoSkippable(level)
    )
  );
}

export function addSpacesRequirementsMet(structure: LevelType[]): boolean {
  return getBaseLayoutOrderedLevels(structure).every(isAddSpacesLevelComplete);
}
